import { gql } from '@efficiently/client-core-graphql-models';

/**
 * Creates one markup on a target.
 *
 * `input` is the contract's `CreateMarkupInput`: the three target fields are **nested inside
 * `target`**, never flattened onto the input, and `style` is non-null — a create without it is
 * `VALIDATION` (Markup contract §1, §3.2).
 *
 * The selection set is `MARKUP_FIELDS`, shared with `GET_MARKUPS` and `UPDATE_MARKUP` (KD-9), so the
 * created row and a listed one are the same shape for the store to reconcile against.
 */
export const CREATE_MARKUP = gql(`
	mutation CreateMarkup($input: CreateMarkupInput!) {
		createMarkup(input: $input) {
			...MarkupFields
		}
	}
`);
